import AppHelmet from 'components/AppHelmet';
import NotFoundResult from 'components/NotFoundResult';

const NotFoundPage = () => {
  return (
    <main className="flex h-screen w-screen items-center justify-center p-15 dark:bg-accent">
      <AppHelmet title="Không tìm thấy trang" />
      <NotFoundResult />
    </main>
  );
};

export default NotFoundPage;
